<template>
    <div class="stream-info">
        <div class="stream-info__mobile-divider" v-if="this.stream"></div>
        <div class="stream-info__data big-text" v-if="this.stream">
            
            {{stream.attributes.location}}<br><br>
            
            <template v-if="stream.attributes.soundcamp">Sound camp </template>
            <template v-else>Stream </template>by {{stream.attributes.streamers}}<br><br>
            <div class="stream-info__data-grid">
                <div>
                    <span v-if="stream.attributes.latitude.length>10">
                        {{stream.attributes.latitude.substring(0,10)}}°
                    </span>
                    <span v-else>
                        {{stream.attributes.latitude}}
                    </span>
                    <br>
                    <span v-if="stream.attributes.longitude.length>10">
                        {{stream.attributes.longitude.substring(0,10)}}°
                    </span>
                    <span v-else>
                        {{stream.attributes.longitude}}
                    </span>
                </div>
                <div>
                    UTC 
                    <span v-if="stream.attributes.utcOffsetMins!=''">
                        <span v-if="stream.attributes.utcOffset>=0">+</span>{{(stream.attributes.utcOffsetMins/60.0)+stream.attributes.utcOffset}}
                    </span>
                    <span v-else>
                        <span v-if="stream.attributes.utcOffset>=0">+</span>{{stream.attributes.utcOffset}}
                    </span>
                </div>
            </div>
            <br>
            <div class="stream-info__data-grid">
                <div>
                    Civil Twilight:<br>{{stream.attributes.twilight}}
                </div>
                <div>
                    Sunrise:<br>{{stream.attributes.sunrise}}
                </div>
            </div>
            <br>
            <div class="stream-info__feature-code-container">
                <div v-if="stream.attributes.soundcamp == false" class="stream-info__dot " :class="['feature-'+stream.attributes.featureCode]"></div>
                <div v-else class="stream-info__triangle " :class="['feature-'+stream.attributes.featureCode]"></div>&nbsp;<span>{{stream.attributes.featureText}}</span>
            </div>
        </div><div 
            class="stream-info__image" v-if="this.stream">
            <img v-if="this.stream.attributes.primaryImageUrl" :src="stream.attributes.primaryImageUrl" ref="image">
        </div><div 
            class="stream-info__description" ref="descriptionText">
            <div class="stream-info__description-text" v-if="this.stream">
                <span v-if="stream.attributes.mainContent==''" v-html="stream.attributes.shortDescription"></span>
                <span v-else v-html="stream.attributes.mainContent"></span>
            </div>
            <div class="stream-info__view-stream-page" ref="viewStreamPage">
                <br>
                <a v-if="this.stream" :href="stream.links.soundtent_url"
                 target="_blank">View stream page</a>
            </div>
        </div>
    </div>
</template>


<script type="text/javascript">

import $ from 'jquery';

export default {
    name: 'StreamInfo',
    components: {},
    props: ['stream'],
    mounted() {
        window.addEventListener("resize", this.positionViewStreamPage);
        this.positionViewStreamPage();
    },

    destroyed() {
        window.removeEventListener("resize", this.positionViewStreamPage);
    },
    methods: {
        positionViewStreamPage(e) {
            var streamPage = $(this.$refs.viewStreamPage);
            var descriptionText = $(this.$refs.descriptionText);
            var offset = descriptionText.height() % descriptionText.css("line-height").replace("px","");
            streamPage.css("bottom",offset+"px");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/StreamInfo.vue